import { render, staticRenderFns } from "./Todo.vue?vue&type=template&id=c5177bcc&"
import script from "./Todo.vue?vue&type=script&lang=js&"
export * from "./Todo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports